import { Button, Dropdown, Switch, Tooltip } from "antd";
import React, { memo, useEffect, useRef, useState } from "react";
import Flickity from "react-flickity-component";
import { Else, If, Then } from "react-if";
import InfiniteScroll from "react-infinite-scroller";
import {
  closeChatLink,
  DownArrow,
  MenuIcon,
  nextgenWelcomeIcon,
  SendIcon,
  sendLinkChatIcon,
  SendLinkIcon,
  spellCheckIcon,
  InfoOutlineIcon,
  TranslatePreviewIcon,
} from "../../../../assets/svg";
import ConfirmPopup from "../../../../components/confirmPopup";
import CustomButton from "../../../../components/customButton";
import LoadingSpinner from "../../../../components/loadingSpinner";
import {
  LANGUAGE_FULLFORMS,
  MOBILE_WIDTH,
  NEXTGEN_EHR_WHITELABEL,
  quickReplyMenu,
} from "../../../../constants/constants";
import ChatHeader from "../chatHeader/chatHeader";
import QuickReply from "../quickReply";
import welcomeChatIcon from "../../../../images/chat/welcome.png";
import { DISABLE_SECURED_CHAT } from "../../../../constants/constants";
import "./chat.scss";
import useOutsideAlerter from "../../../../components/custom-hooks/useOutsideAlerter";
import useWindowDimensions from "../../../../components/custom-hooks/useWindowDimensions";
import TransferPopup from "../../../transferPopup";
import { bindActionCreators } from "redux";
import { revokePatientByUser } from "../../../../sagas/saga-revoke";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";

const ChatInner = (props) => {
  const {
    chatProps,
    chatState,
    loadMore,
    displayChat,
    handleQuickReply,
    claimedPatient,
    handleSendLink,
    getQuickReplyList,
    handleSubmit,
    textInputRef,
    sendMessageRef,
    handleSendLinkModal,
    handleCancel,
    handleHideQuickReply,
    handleChatInput,
    handleCloseChatLink,
    handleClaimButton,
    closeSendLinkModal,
    handleSecureChat,
    handlspellCheck,
    closeSecureChatModal,
    activateSecureSession,
    closeSecureChatTime,
    deactivateSecureSession,
    secureLinkClose,
    patient,
    activeSpellCheck,
    spellSuggestionState,
    setSuggestionState,
    handleChange,
    translationPreview,
    isTranslating,
    setValueState,
    igonreSpellCheckWord,
    setMainState,
    transferNumberState = false,
    releaseNumberState = false,
    setIsNewMessageNotificationVisible,
    isNewMessageNotificationVisible,
    scrollToBottom,
    detectedLanguage,
    isTranslationEnabled,
    isAutoTranslationEnabled,
    handleAutoTranslationToggle,
    isEnglishOnlyInput,
    handlePaste,
  } = props;

  const {
    handleShowDetails,
    user,
    patients,
    handleStaffChange,
    handleChat,
  } = chatProps;

  const {
    claimedPopup,
    hasMore,
    sendLink,
    quickReplyModal,
    quickReplyList,
    value,
    allowTyping,
    uploadLink,
    activateSecureChat,
    showSecureTimePopUp,
    showSecureTimeMsg,
    deactivateSecureChat,
    endSecureSessionChat,
    secureSessionIsActive,
    secureChatLinkStatus,
    messages,
    isApiLoading,
  } = chatState;
  const chatcontainerRef = useRef();
  const lastScrollTopRef = useRef(0);
  const [isAtBottom, setIsAtBottom] = useState(true);
  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef, setSuggestionState);
  const tabSet = localStorage.getItem("tabSet");
  const mngQckRplyAccess = user && user.manageQuickReply ? true : false;
  const roleKey = user?.roles?.roleKey;
  const disableChatCheck =
    roleKey === "OU" || roleKey === "TS"
      ? patients.patient?.claimedUserId === user?.lcUser?.id.toString()
      : patients.patient?.claimedUserId === user?.id.toString();

  const [disableSpellCheck, setDisableSpellCheck] = useState(true);
  const { width } = useWindowDimensions();
  const history = useHistory();
  const normalizedDetectedLanguage = detectedLanguage
    ? detectedLanguage.toLowerCase()
    : "";
  useEffect(
    () => {
      if (
        !textInputRef?.current?.innerHTML ||
        textInputRef?.current?.innerHTML === "<br>"
      ) {
        setDisableSpellCheck(true);
      } else {
        setDisableSpellCheck(false);
      }
    },
    [textInputRef?.current?.innerHTML],
  );

  const ignoreSpell = () => {
    const selection = window.getSelection();
    if (selection?.rangeCount > 0) {
      const range = selection.getRangeAt(0);
      igonreSpellCheckWord(range?.startContainer?.data);
      const className = selection?.anchorNode?.parentNode?.className;
      const elements = Array.from(document.getElementsByClassName(className));
      if (elements?.length) {
        elements.forEach((element) => {
          element.style.backgroundColor = null;
          element.classList.remove("ignored-highlight");
        });
      }
      selection.removeAllRanges();
    }
    setSuggestionState((st) => ({
      x: null,
      y: null,
      opened: false,
      wordId: null,
      selectedSuggestions: [],
      suggestions: [],
    }));
  };

  const changeSpelling = (word) => {
    const element = spellSuggestionState.wordId.target;
    element.outerHTML = word;
    setSuggestionState((st) => ({
      x: null,
      y: null,
      opened: false,
      wordId: null,
      selectedSuggestions: [],
      suggestions: [],
    }));
    setValueState((st) => ({
      ...st,
      postVal: textInputRef?.current?.innerText,
      value: textInputRef?.current?.innerText,
    }));
  };

  const getSuggestionText = (suggestion) => {
    if (typeof suggestion === "string" || typeof suggestion === "number") {
      return String(suggestion).trim();
    }

    if (!suggestion || typeof suggestion !== "object") {
      return "";
    }

    const suggestionText =
      suggestion.suggestion ||
      suggestion.value ||
      suggestion.word ||
      suggestion.text;

    if (
      typeof suggestionText === "string" ||
      typeof suggestionText === "number"
    ) {
      return String(suggestionText).trim();
    }

    return "";
  };

  const spellSuggestionList = (Array.isArray(spellSuggestionState?.suggestions)
    ? spellSuggestionState.suggestions
    : [spellSuggestionState?.suggestions]
  )
    .map((suggestion) => getSuggestionText(suggestion))
    .filter(Boolean);

  const handleClose = () => {
    setMainState((st) => ({
      ...st,
      transferNumberState: false,
    }));
  };

  const revokePatient = () => {
    const { user, patients } = props;
    const object = {
      userId: user.id,
      patientId: patients.patient.id,
    };
    props.revokePatientByUser(object, () => {
      props.PatientCount();
      const event = new CustomEvent("revokeUser");
      window.dispatchEvent(event);
    });
    history.push("/");
  };
  const handleDelete = () => {
    claimedPatient({
      userId: user.id.toString(),
      patientId: patients.patient.id,
      userName: user && user.username ? user.username : "",
    });
    setValueState((st) => ({ ...st, claimedPopup: false }));
  };

  const checkPosition = () => {
    const container = chatcontainerRef.current;
    if (container) {
      const currentScrollTop = container.scrollTop;

      // Update scroll direction and position check and
      // added 5px because if it slightly up then it will consider it as bottom only
      const isAtBottomNow =
        container.scrollHeight - container.scrollTop <=
        container.clientHeight + 5;

      setIsAtBottom(isAtBottomNow);

      // Scroll to bottom  when user is at the bottom
      if (isAtBottomNow) {
        scrollToBottom();
        setIsNewMessageNotificationVisible(false);
      }

      lastScrollTopRef.current = currentScrollTop; // Update last scroll position
    }
  };

  useEffect(() => {
    const container = chatcontainerRef.current;
    if (container) {
      const handleScroll = () => {
        checkPosition();
      };

      // Attach the scroll listener
      container.addEventListener("scroll", handleScroll);

      // Clean up the event listener on unmount
      return () => {
        container.removeEventListener("scroll", handleScroll);
      };
    }
  }, []);

  // Handle new messages scroll behavior
  useEffect(
    () => {
      if (isAtBottom) {
        scrollToBottom(); // Scroll to bottom if user is at the bottom when a new message arrives
      }
    },
    [chatState],
  );

  const onClickNewNotification = () => {
    if (!isAtBottom) scrollToBottom();
  };

  return (
    <>
      {transferNumberState && (
        <TransferPopup handleCancel={handleClose} handleChat={handleChat} />
      )}
      {releaseNumberState && (
        <ConfirmPopup
          titleMessage="Confirm to Release"
          handleCancel={() =>
            setMainState((st) => ({ ...st, releaseNumberState: false }))
          }
          handleDelete={revokePatient}
          isVisible={releaseNumberState}
          submitButtonText="Release"
          cancelButtonText="Cancel"
          message="Are you sure you want to release this patient?"
        />
      )}
      <If condition={claimedPopup}>
        <Then>
          <ConfirmPopup
            titleMessage="Confirm to Claim"
            handleCancel={handleCancel}
            handleDelete={handleDelete}
            isVisible={claimedPopup}
            submitButtonText="Claim"
            cancelButtonText="Cancel"
            message="Are you sure you want to claim this patient for communication?"
          />
        </Then>
      </If>

      <If condition={sendLink}>
        <Then>
          <ConfirmPopup
            titleMessage="Confirm to attach link"
            handleCancel={closeSendLinkModal}
            handleDelete={handleSendLink}
            isVisible={sendLink}
            submitButtonText="Yes"
            cancelButtonText="No"
            message="Attach a file upload link to the patient?"
          />
        </Then>
      </If>
      <If condition={endSecureSessionChat}>
        <Then>
          <ConfirmPopup
            isDelete
            titleMessage="Session is expired."
            handleDelete={deactivateSecureSession}
            isVisible={endSecureSessionChat}
            submitButtonText="Ok"
          />
        </Then>
      </If>
      <If condition={secureChatLinkStatus}>
        <Then>
          <ConfirmPopup
            isDelete
            titleMessage="Secure session has not started."
            handleDelete={secureLinkClose}
            isVisible={secureChatLinkStatus}
            submitButtonText="Ok"
          />
        </Then>
      </If>

      <If condition={activateSecureChat}>
        <Then>
          <ConfirmPopup
            titleMessage="Secure Session"
            handleCancel={closeSecureChatModal}
            handleDelete={activateSecureSession}
            isVisible={activateSecureChat}
            submitButtonText="Start Session"
            cancelButtonText="Cancel"
            message={
              <>
                Are you sure you want to start a secure, encrypted session with{" "}
                <strong>
                  {" "}
                  {patient?.firstName || patient?.lastName
                    ? `${patient.firstName} ${patient.lastName || ""}`
                    : patient.cellPhone}{" "}
                </strong>
                ?
              </>
            }
          />
        </Then>
      </If>
      <If condition={showSecureTimePopUp}>
        <Then>
          <ConfirmPopup
            message
            titleMessage={`This session will be valid for ${showSecureTimeMsg} min.`}
            handleDelete={closeSecureChatTime}
            isVisible={showSecureTimePopUp}
            submitButtonText="Ok"
          />
        </Then>
      </If>
      <If condition={deactivateSecureChat}>
        <Then>
          <ConfirmPopup
            isDelete
            titleMessage="Secure Session"
            handleCancel={closeSecureChatModal}
            handleDelete={deactivateSecureSession}
            isVisible={deactivateSecureChat}
            submitButtonText="End Session"
            cancelButtonText="Cancel"
            message={
              <>
                Messages sent via SMS are not encrypted and are vulnerable, Are
                you sure you want to end the secure encrypted session with
                <strong>
                  {" "}
                  {patient.firstName || patient?.lastName
                    ? `${patient.firstName} ${patient.lastName || ""}`
                    : patient.cellPhone}{" "}
                </strong>
                ?
              </>
            }
          />
        </Then>
      </If>
      <If condition={quickReplyModal}>
        <Then>
          <QuickReply
            title="Manage Quick Reply"
            isVisible={quickReplyModal}
            hideQuickReply={handleHideQuickReply}
            quickReplyList={quickReplyList}
            getQuickReplyList={getQuickReplyList}
          />
        </Then>
      </If>
      <div className="chat-main-content">
        <If condition={patients.patient}>
          <Then>
            <>
              <ChatHeader
                handleShowDetails={handleShowDetails}
                handleChat={handleChat}
                secureSessionIsActive={secureSessionIsActive}
              />
              {isNewMessageNotificationVisible &&
                !isAtBottom && (
                  <div className="new-message-notification">
                    <button
                      onClick={onClickNewNotification}
                      className="scroll-to-bottom-btn"
                    >
                      <DownArrow /> New messages
                    </button>
                  </div>
                )}
              <div className="chat-messages-container" ref={chatcontainerRef}>
                <InfiniteScroll
                  pageStart={0}
                  loadMore={loadMore || isApiLoading}
                  hasMore={hasMore}
                  loader={
                    <LoadingSpinner
                      type="small"
                      relative
                      customClassName="without-background-transparent"
                    />
                  }
                  isReverse={true}
                  threshold={50}
                  initialLoad={true}
                  useWindow={false}
                >
                  <div
                    className="messages-container"
                    id="messages"
                    ref={(node) => {
                      // eslint-disable-next-line no-self-assign
                      node = node;
                    }}
                  >
                    {displayChat()}
                  </div>
                </InfiniteScroll>
              </div>

              <section
                className={
                  !Boolean(messages.length) && width < MOBILE_WIDTH
                    ? "reply-main-container"
                    : ""
                }
              >
                <If condition={tabSet === "activeItem"}>
                  <Then>
                    <section className="quick-replies-main-container">
                      <If condition={quickReplyList.length > 0}>
                        <Then>
                          <Flickity
                            options={{
                              initialIndex: 0,
                              prevNextButtons: true,
                              groupCells: true,
                              cellAlign: "left",
                            }}
                          >
                            {quickReplyList.map((item) => (
                              <div className="button-wrapper">
                                <CustomButton
                                  btntype="primary"
                                  title={item?.quickTitle || item.quickMessage}
                                  className="cancel-button quick-reply"
                                  onClick={(e) => handleSubmit(e, item.id)}
                                />
                              </div>
                            ))}
                          </Flickity>
                        </Then>
                        <Else>
                          <div className="static-message">
                            No quick reply has been added yet.
                          </div>
                        </Else>
                      </If>
                      <div className="quick-reply-menu-actions">
                        <Dropdown
                          overlayClassName="custom-icons-dropdown"
                          overlay={() =>
                            quickReplyMenu(
                              getQuickReplyList,
                              () => handleQuickReply(true),
                              mngQckRplyAccess,
                            )
                          }
                          trigger={["click"]}
                          placement="topRight"
                          //disabled={!messages.length > 0 ? true : false}
                        >
                          <div className="menu-icon">
                            <MenuIcon />
                          </div>
                        </Dropdown>
                      </div>
                    </section>
                  </Then>
                </If>

                <If condition={patients.patient && user && disableChatCheck}>
                  <Then>
                    <If condition={user && user.liveChatEnabled}>
                      <Then>
                        <div className="send-message-container">
                          <form onSubmit={handleSubmit}>
                            <section className="input-with-link-wrapper">
                              {isTranslationEnabled &&
                                !secureSessionIsActive &&
                                isAutoTranslationEnabled &&
                                translationPreview &&
                                detectedLanguage &&
                                (normalizedDetectedLanguage !== "en" &&
                                  LANGUAGE_FULLFORMS[
                                    normalizedDetectedLanguage
                                  ] && (
                                    <div className="translation-preview">
                                      <span className="translation-label">
                                        <TranslatePreviewIcon />
                                        {isTranslating
                                          ? "Translating..."
                                          : `Translation Preview (${
                                              LANGUAGE_FULLFORMS[
                                                normalizedDetectedLanguage
                                              ]
                                            }):`}
                                      </span>
                                      <div className="translation-text">
                                        {translationPreview}
                                      </div>
                                    </div>
                                  ))}

                              {spellSuggestionState.opened && (
                                <div
                                  style={{
                                    top:
                                      width > MOBILE_WIDTH
                                        ? spellSuggestionState.y - 45 + "px"
                                        : !Boolean(messages.length)
                                          ? -60 + "px"
                                          : spellSuggestionState.y + 10 + "px",
                                    left:
                                      width > MOBILE_WIDTH
                                        ? spellSuggestionState.x + "px"
                                        : spellSuggestionState.x > 200
                                          ? spellSuggestionState.x - 80 + "px"
                                          : spellSuggestionState.x,
                                  }}
                                  className="suggestions-box"
                                  ref={wrapperRef}
                                >
                                  <div className="suggestion-header">
                                    {spellCheckIcon}{" "}
                                    <span className="spell-checker-heading">
                                      Spell Checker
                                    </span>
                                  </div>
                                  {spellSuggestionList.length > 0 && (
                                    <>
                                      <section className="spell-box">
                                        {spellSuggestionList.map(
                                          (elem, index) => {
                                            return (
                                              <div
                                                key={`${elem}-${index}`}
                                                onClick={() => {
                                                  changeSpelling(elem);
                                                }}
                                                className="spell-suggestions"
                                              >
                                                {elem}
                                              </div>
                                            );
                                          },
                                        )}
                                      </section>
                                      <Button
                                        size="large"
                                        className="spell-checker-ignore-btn"
                                        onClick={() => {
                                          ignoreSpell();
                                        }}
                                      >
                                        <span className="ignore-text">
                                          Ignore
                                        </span>
                                      </Button>
                                    </>
                                  )}
                                  {spellSuggestionList.length < 1 && (
                                    <>
                                      <section className="spell-box">
                                        <span className="spell-suggestions">
                                          No suggestions found
                                        </span>
                                      </section>
                                      <div>
                                        <Button
                                          size="large"
                                          className="spell-checker-ignore-btn"
                                          onClick={() => {
                                            ignoreSpell();
                                          }}
                                        >
                                          Ignore
                                        </Button>
                                      </div>
                                    </>
                                  )}
                                </div>
                              )}
                              <div
                                contentEditable={
                                  !allowTyping ||
                                  (user &&
                                    user?.liveChatEnabled &&
                                    !isApiLoading)
                                    ? true
                                    : false
                                }
                                className="input-div"
                                onInput={handleChange}
                                placeholder={
                                  isEnglishOnlyInput
                                    ? "Type a message in English only for auto-translation"
                                    : "Type a message..."
                                }
                                id="textInput"
                                value={value}
                                onKeyDown={(e) => {
                                  if (e.key === "Enter") {
                                    e.preventDefault();
                                    handleChatInput(e);
                                  }
                                }}
                                ref={textInputRef}
                                spellCheck={false}
                                onPaste={handlePaste}
                              />
                              {uploadLink && (
                                <span className="link-wrapper">
                                  {sendLinkChatIcon}

                                  <p className="link-text">{uploadLink}</p>

                                  <span
                                    className="close-chat-link"
                                    onClick={handleCloseChatLink}
                                  >
                                    {closeChatLink}
                                  </span>
                                </span>
                              )}
                            </section>

                            <section
                              className={`input-buttons-container ${uploadLink &&
                                "input-buttons-container-link"}`}
                            >
                              <div className="extra-buttons">
                                {!uploadLink &&
                                  !secureSessionIsActive && (
                                    <CustomButton
                                      btntype="clear"
                                      title={
                                        <div className="send-link-button-wrapper">
                                          <SendLinkIcon />

                                          {width > MOBILE_WIDTH &&
                                            "Attach Link"}
                                        </div>
                                      }
                                      onClick={handleSendLinkModal}
                                      disabled={
                                        user && user.liveChatEnabled
                                          ? false
                                          : true
                                      }
                                    />
                                  )}
                                <div className="button-divider" />
                                <div className="switch-wrapper spell-check">
                                  {width < MOBILE_WIDTH && (
                                    <span className="spell-check-icon">
                                      {spellCheckIcon}
                                    </span>
                                  )}
                                  <span className="pre-text hide-for-mob ">
                                    Spell Check
                                  </span>
                                  <Switch
                                    onChange={(value) => {
                                      handlspellCheck(value);
                                    }}
                                    defaultChecked
                                    checked={activeSpellCheck}
                                    size="small"
                                  />
                                </div>
                                {isTranslationEnabled &&
                                  !secureSessionIsActive && (
                                    <>
                                      <div className="button-divider" />
                                      <div className="switch-wrapper auto-translation">
                                        <span className="pre-text hide-for-mob ">
                                          Auto-translation
                                        </span>
                                        <Tooltip title="Automatically translate outgoing messages using the detected language from the chat.">
                                          <span className="translation-info-icon">
                                            <InfoOutlineIcon />
                                          </span>
                                        </Tooltip>
                                        <Switch
                                          onChange={handleAutoTranslationToggle}
                                          checked={isAutoTranslationEnabled}
                                          size="small"
                                        />
                                      </div>
                                    </>
                                  )}
                              </div>

                              <div className="send-options">
                                {!DISABLE_SECURED_CHAT &&
                                  user?.practice?.ehrName === "Epic" &&
                                  (!patient.isVacPatient ||
                                    (patient.isVacPatient &&
                                      patient.convoType === "SMS")) &&
                                  (!uploadLink && (
                                    <div className="switch-wrapper">
                                      <span className="pre-text hide-for-mob">
                                        Send Securely
                                      </span>
                                      <Switch
                                        name="activateSecureChat"
                                        onChange={(value) => {
                                          handleSecureChat(value);
                                        }}
                                        checked={secureSessionIsActive}
                                        size="small"
                                      />
                                    </div>
                                  ))}

                                <div className="divider" />

                                <Button
                                  type="text"
                                  className="chatInputSubmit"
                                  onClick={handleSubmit}
                                  disabled={
                                    user &&
                                    user?.liveChatEnabled &&
                                    !sendMessageRef.current &&
                                    !isTranslating
                                      ? false
                                      : true
                                  }
                                >
                                  <SendIcon />
                                </Button>
                              </div>
                            </section>
                          </form>
                        </div>
                      </Then>

                      <Else>
                        <div className="limited-user-message">
                          No number has been alloted. You won't be able to send
                          or receive messages.{" "}
                          <strong>Please contact admin</strong>
                        </div>
                      </Else>
                    </If>
                  </Then>
                </If>
              </section>
              <If condition={tabSet && tabSet !== "activeItem"}>
                <Then>
                  <div
                    className={
                      !Boolean(messages.length) && width < MOBILE_WIDTH
                        ? "claim-panel no-message"
                        : "claim-panel"
                    }
                  >
                    <span className="claim-message">
                      <button
                        className="claim-button"
                        onClick={() => {
                          handleClaimButton();
                          handleStaffChange();
                        }}
                      >
                        Claim
                      </button>{" "}
                      this chat to communicate with this person
                    </span>
                  </div>
                </Then>
              </If>
            </>
          </Then>

          <Else>
            <div className="chat-welcome-message">
              {NEXTGEN_EHR_WHITELABEL ? (
                nextgenWelcomeIcon
              ) : (
                <img src={welcomeChatIcon} alt="" />
              )}
              <section className="content">
                <p className="heading">Nothing to show</p>

                <p className="message">
                  Please select active chats from the left panel and start
                  conversing.
                </p>
              </section>
            </div>
          </Else>
        </If>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    patients: state.patients,
    user: state.login.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    revokePatientByUser: bindActionCreators(revokePatientByUser, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(memo(ChatInner));
